
angular.module('bmsApp.directives').directive('activityColourSelector', [
	'ActivityColourSvc', function (
		ActivityColourSvc) {

		return {
			restrict: 'E',
			require: 'ngModel',
			scope: {
				ngModel: '='
			},
			replace: true,
			templateUrl: 'ng/crm/activity/directives/activityColourSelector/ActivityColourSelector.html',
			link: function (scope) {

				scope.activityColourOptions = [];

				ActivityColourSvc.options()
					.then(function (response) {
						scope.activityColourOptions = response.data.options;
					});

				scope.select = function (option) {
					// toggle/switch colour
					scope.ngModel = scope.activityColourComparator(option, scope.ngModel) ? scope.ngModel = false : scope.ngModel = option;
				};

				scope.activityColourComparator = function (obj1, obj2) {
					// id is only thing that matters
					return angular.isObject(obj1) && angular.isObject(obj2) && obj1.id === obj2.id;
				};

			}
		};

}]);
